import { logger } from './logger';

/**
 * Axios `baseURL` must be an absolute URL. A hostname-only value such as
 * `partner-connect-backend.haat.delivery` is treated as a relative path, so
 * the browser nests it under the SPA origin
 * (`https://partner-connect.haat.delivery/partner-connect-backend.haat.delivery/...`).
 *
 * Prefixes `https://` when the scheme is missing (or `http://` for localhost).
 */

export const ensureAbsoluteHttpUrl = (rawUrl: string): string => {
  const trimmed = rawUrl.trim();
  if (!trimmed) return trimmed;
  if (/^[a-z][a-z\d+\-.]*:\/\//i.test(trimmed)) return trimmed;
  if (trimmed.startsWith('//')) return `https:${trimmed}`;

  const host = trimmed.split('/')[0]?.split(':')[0] ?? '';
  const isLocal = host === 'localhost' || host === '127.0.0.1';
  const absolute = `${isLocal ? 'http' : 'https'}://${trimmed}`;
  logger.warn(
    '[HAAT Partner Connect] REACT_APP_API_BASE_URL is missing a scheme; prefixed so requests are not relative to the SPA origin',
    { from: trimmed, to: absolute },
  );
  return absolute;
};
